<!--
 * @Description: 代办事项
 * @Author: xiawenlong
 * @Date: 2021-04-22 19:46:51
 * @LastEditors: xiawenlong
 * @LastEditTime: 2021-04-22 19:47:10
-->
<template>
  <div class="card todo">
    <div class="header">
      <div class="title">课程销量排名</div>
    </div>
    <div class="content">
      <ul class="todo-list">
        <li v-for="(item, index) in saleRankList" :key="index">
          <!-- <img src="@/assets/common/todo_icon.png" alt="" /> -->
          <span class="sort">{{ index + 1 }}</span>
          <p>{{ item.name }}</p>
          <span>{{ item.sale }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CourseSalseRankCard',
  props: {
    saleRankList: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
<style lang="scss" scoped>
.card {
  &.todo {
    width: 463px;
    height: 307px;
    margin-left: 20px;
    .todo-list {
      padding: 0 25px;
      overflow: hidden;
      overflow-y: auto;
      height: 243px;
      li {
        position: relative;
        padding: 10px 0 13px 11px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #eee;
        font-size: 14px;
        .sort {
          border: 1px solid #e2e2e2;
          padding: 1px 8px;
          border-radius: 50%;
          margin-right: 20px;
        }
        &:nth-child(1) {
          .sort {
            background: #333333;
            color: #ffffff;
          }
        }
        &:nth-child(2) {
          .sort {
            background: #333333;
            color: #ffffff;
          }
        }
        &:nth-child(3) {
          .sort {
            background: #333333;
            color: #ffffff;
          }
        }
        p {
          flex: 1;
        }
        span {
          font-weight: 400;
          color: #999999;
        }
      }
    }
  }
}
</style>
